import { render, staticRenderFns } from "./CompanyForm.vue?vue&type=template&id=2ca91a62"
import script from "./CompanyForm.vue?vue&type=script&lang=js"
export * from "./CompanyForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2ca91a62')) {
      api.createRecord('2ca91a62', component.options)
    } else {
      api.reload('2ca91a62', component.options)
    }
    module.hot.accept("./CompanyForm.vue?vue&type=template&id=2ca91a62", function () {
      api.rerender('2ca91a62', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/company/CompanyForm.vue"
export default component.exports